<template lang="pug">
div
  app-modal-visualizar-completo(
    v-if="showModalVisualizarProcesso && idProcesso !== null",
    @closeModal="showModalVisualizarProcesso = false",
    :idProcesso="idProcesso",
    :protocolo="protocolo",
    :numeroProcesso="numeroProcesso",
    :tipo="tipoProcesso"
  )
  el-card.card-container(shadow="hover")
    filtro(
      @pesquisar="pesquisar",
      @limpar="clear",
      :showOs="true",
      :showMunicipios="true",
      :configuracaoFiltro="configuracaoFiltro",
      :filtroRapido="filtroRapido"
    )
  app-listagem(
    :has-refresh-button="true",
    :showButtonOrdemServico="false",
    :showButtonAssinatura="false",
    :has-expansivel="false",
    :json-headers="colunas",
    :json-data="items",
    :totalElements="totalElements",
    :pagina="filtro.pagina",
    :hasFiltroRapido="true",
    :filtro="filtro",
    @atualizarFiltro="atualizarFiltro",
    @updateListagem="refresh",
    @changePage="changePage",
    @sort="sort",
    @executar="executar",
    @selected="false"
  )
</template>

<script>
import { mapActions } from 'vuex'
import AppListagem from '@/components/AppListagem'
import Filtro from './Filtro'
import FILTRO_EMPTY from '@/models/filtro'
import AppModalVisualizarCompleto from '@/screens/analise/components/modal/AppModalVisualizarCompleto'
import AppNotificacao from '@/components/mixins/AppNotificacao'
const BaseFiltro = require('./' + process.env.ESTADO + '/BaseFiltro').default
const { filtro } = require('@/utils/' + process.env.ESTADO + '/regrasAnalise').default

export default {

  beforeRouteLeave (to, from, next) {
    next()
  },

  components: {
    AppListagem,
    Filtro,
    AppModalVisualizarCompleto
  },

  mixins: [
    BaseFiltro,
    AppNotificacao
  ],

  data () {
    return {
      filtro: FILTRO_EMPTY('AGUARDANDO_CALCULO_CUSTAS'),
      items: [],
      totalElements: 0,
      processosSelecionados: [],
      showModalVisualizarProcesso: false,
      processoTrocado: null,
      idProcesso: null,
      numeroProcesso: null,
      tipoProcesso: null,
      protocolo: null,
      configuracaoFiltro: {
        filtroSituacao: filtro?.filtroSituacao?.AGUARDANDO_CALCULO_CUSTAS || [],
        filtroMunicipio: filtro?.filtroMunicipio?.AGUARDANDO_CALCULO_CUSTAS || []
      },
      colunas: [
        { id: 0, titulo: 'Processo', propriedade: 'numeroProcesso', ordem: 1, acoes: [], type: 'icone', icone: 'comment-alt' },
        { id: 1, titulo: 'CPF/CNPJ do Interessado', propriedade: 'cpfCnpjInteressado', ordem: 2, acoes: [] },
        { id: 2, titulo: 'Nome/Razão Social do Interessado', propriedade: 'nomeRazaoSocialInteressado', ordem: 3, acoes: [] },
        { id: 3, titulo: 'Situação', propriedade: 'status', ordem: 4, acoes: [] },
        { id: 4, titulo: 'Município', propriedade: 'municipio', sortable: true, ordem: 3, acoes: [] },
        { id: 5, titulo: 'Data Chegada', propriedade: 'dataChegadaSetor', ordem: 4, acoes: [] },
        { id: 6, titulo: 'Tipo de Processo', propriedade: 'tipo', ordem: 5, acoes: [] },
        {
          id: 7, titulo: 'Ações', propriedade: 'tipo', ordem: 6, //eslint-disable-line
          acoes: [
            { id: 1, nome: 'Visualizar Processo', icone: 'fa-eye', codigo: 'VISUALIZAR_PROCESSO', ordem: 1, show: this.showVisualizarProcesso },
            { id: 2, nome: 'Calcular Custas', icone: 'fa-file-invoice-dollar', codigo: 'GERAR_CUSTAS_CERTIDAO', ordem: 2, show: this.showGerarCustasCertidao }
          ]
        }
      ],
      filtroRapido: null
    }
  },

  props: {
    tipo: {
      type: String,
      required: false // trocar para true, quando tiver a props
    }
  },

  methods: {
    ...mapActions({
      retornarSetor: 'processo/retornarSetor'
    }),
    VISUALIZAR_PROCESSO (_this, { item }) {
      this.idProcesso = item.id
      this.numeroProcesso = item.numeroProcesso
      this.tipoProcesso = item.tipoCodigo
      this.protocolo = item.numeroProtocolo
      this.showModalVisualizarProcesso = true
    },
    GERAR_CUSTAS_CERTIDAO: async (_this, { item }) => {
      _this.$router.push({
        name: 'analise/emissao-custas-certidao',
        params: {
          idProcesso: item.id
        }
      })
    },
    atualizarFiltro (novoFiltro) {
      this.filtroRapido = novoFiltro
    }
  }
}
</script>
<style lang="scss" scoped>
.card-container {
  margin: 20px;
  border-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/listagem/CaixaCustasCertidaoListagem.vue